import type { ReactElement } from "react";

export interface SessionTimelineStep {
  description: string;
  time: string;
  title: string;
}

interface SessionTimelineProps {
  steps: SessionTimelineStep[];
}

export const SessionTimeline = ({ steps }: SessionTimelineProps): ReactElement => (
  <ol className="newborn-session-timeline">
    {steps.map((step, index) => (
      <li key={step.title}>
        <span aria-hidden="true" className="newborn-session-timeline__number">
          {String(index + 1).padStart(2, "0")}
        </span>
        <div>
          <p className="newborn-session-timeline__time">{step.time}</p>
          <h3>{step.title}</h3>
          <p>{step.description}</p>
        </div>
      </li>
    ))}
  </ol>
);
